import React from 'react';
import '../../../assets/css/style.css';
import '../../../assets/css/bootstrap.css';

const ThirdInfo = () => {
    return (
        <div class="container">

            <div class="row-1">
                <img src="img/logo-mark.png" alt="Universe" width="50px" height="auto"/>
                <h3>Welcome to Univrs</h3>
                <h5>Where finding college romance is a step easier</h5>
            </div>

            <div class="row-2">
                <h2>Pictures are only revealed when you both feel comfortable</h2>
            </div>

            <div class="row-3">
                <div class="intro-wrapper">
                    <p class="intro-body">
                        You have the power and freedom to reveal your photos to your match when you're both comfortable with each other. Univrs is a safe space for making and ending connections. It doesn't hurt that a little mystery keeps things spicy.
                    </p>
                </div>

                <button type="submit" class="uni-btn">Let's Get Started!</button>
            </div>

            <div class="row-4">

                <button class="nav-button">
                    <i class="btn-icon fa fa-address-book" aria-hidden="true"></i>
                    <span class="btn-txt">Name</span>
                </button>

                <button class="nav-button">
                    <i class="btn-icon fa fa-birthday-cake" aria-hidden="true"></i>
                    <span class="btn-txt">Age</span>
                </button>

                <button class="nav-button">
                    <i class="btn-icon fa fa-venus-mars" aria-hidden="true"></i>
                    <span class="btn-txt">Gender</span>
                </button>

                <button class="nav-button" active>
                    <i class="btn-icon fa fa-university" aria-hidden="true"></i>
                    <span class="btn-txt">Campus</span>
                </button>

                <button class="nav-button">
                    <i class="btn-icon fa fa-picture-o" aria-hidden="true"></i>
                    <span class="btn-txt">Pictures</span>
                </button>

                <button class="nav-button">
                    <i class="btn-icon fa fa-heart" aria-hidden="true"></i>
                    <span class="btn-txt">Interests</span>
                </button>

            </div>

        </div>
    );
}

export default ThirdInfo;